/**
 * Change review fields into star selectors
 */

import showStars from './showstars';

const reviewFields = () => {
	const fields =
		document.querySelectorAll< HTMLElement >( '.amx-review-field' );
	fields.forEach( ( field ) => {
		showStars( field );
	} );
};

export default reviewFields;
